<template>
    <ion-page>
        <ion-content :fullscreen="true" v-html="language.journeyCopyrightWarning" class="content">
        </ion-content>
        <FixedFooter :buttons="footerButtons"/>
    </ion-page>
</template>

<script lang="ts">

import {IonContent, IonPage} from '@ionic/vue';
import FixedFooter from "@/components/FixedFooter.vue";
import {store} from "@/store/Store";
import {FooterButtonsBuilder} from "@/mixins/FooterButtonsBuilder";
import router from "@/router";
import {computed, ref} from "vue";
import {useStore} from "vuex";
import {defineComponent} from "@vue/runtime-core";
import { execute } from '@/mixins/LoadingMixin';
import {getJourneySet} from "@/services/JourneySetService";
import { getTemplate } from '@/services/TemplateService';

export default defineComponent({
    name: 'JourneyCopyrightWarning',
    components: {
        IonContent,
        IonPage,
        FixedFooter
    },
    props: {
        journeySetId: {
            type: String,
            required: true
        },
        journeyId: {
            type: String,
            required: true
        }
    },
    async ionViewWillEnter() {
        await this.store.dispatch('app/setPageTitle', this.language.journeySetCreation);
        await execute(async () => {
            const journeySet = await getJourneySet(this.journeySetId);
            const template = await getTemplate(journeySet.templateId);
            this.tabCnt = template.tabsCount;
            this.customContentEnabled = template.enableCustomContent;
            if (this.customContentEnabled == undefined) this.customContentEnabled = true;
            this.contentLoaded = true;
        }, this.language.errors.loadingJourney);
    },
    setup(props: any) {
        const contentLoaded = ref(false);
        const customContentEnabled = ref(false);
        const tabCnt = ref(0);
        const getNextPage = () => {

            let pageName = '';
            switch(tabCnt.value) {
                case 1:
                    pageName= 'finalContent';
                    break;
                default:
                    pageName= customContentEnabled.value ? 'introContent' : 'scriptureContent';
                    break;
                }
                
            router.push({
                name: pageName,
                params: {journeySetId: props.journeySetId, journeyId: props.journeyId}
            });
        }

        return {
            contentLoaded,
            customContentEnabled,
            tabCnt,
            store: useStore(),
            language: computed(() => store.getters['app/language']),
            footerButtons: computed(() => 
                new FooterButtonsBuilder()
                .addClearBackButton()
                .addPrimaryNextButton(getNextPage).create()
            )
        }
    }
});
</script>

<style scoped>
.content >>> h2 {
    color: var(--ion-color-primary);
}

.content >>> p {
    font-size: 19px;
    line-height: 25px;
    font-weight: 400;
    color: var(--color-step-200);
}

.content >>> a {
    color: var(--color-step-200);
    font-weight: bold;
}
</style>